<template>
  <div>
    <base-header class="pb-7 pt-5 pt-md-8 bg-gradient-warning">
      <!-- Card stats -->
      <div v-if="Object.keys(productsUnfreezePerCat.today).length > 0 || Object.keys(productsUnfreezePerCat.tomorrow).length > 0 || Object.keys(productsUnfreezePerCat.aftertomorrow).length > 0">
        <div v-if="!isAfternoon && Object.keys(productsUnfreezePerCat.today).length > 0">
          <b-row>
            <b-col><h2>Vandaag opsturen</h2></b-col>
          </b-row>
          <b-row>
            <b-col v-for="(cat, name) in productsUnfreezePerCat.today" :key="'today-'+name" xl="3" md="6" @click="showModal(name, 'today')">
              <stats-card :title="name"
                          type="gradient-orange"
                          :sub-title="cat.toString()"
                          icon="ni ni-tag"
                          class="mb-2">
              </stats-card>
            </b-col>
          </b-row>
        </div>

        <div v-if="Object.keys(productsUnfreezePerCat.tomorrow).length > 0">
          <b-row>
            <b-col><h2>Morgen opsturen</h2></b-col>
          </b-row>
          <b-row>
            <b-col v-for="(cat, name) in productsUnfreezePerCat.tomorrow" :key="'day-'+name" xl="3" md="6" @click="showModal(name, 'tomorrow')">
              <stats-card :title="name"
                          type="gradient-orange"
                          :sub-title="cat.toString()"
                          icon="ni ni-tag"
                          class="mb-2">
              </stats-card>
            </b-col>
          </b-row>
        </div>

        <div v-if="isAfternoon && Object.keys(productsUnfreezePerCat.aftertomorrow).length > 0">
          <b-row>
            <b-col><h2>Overmorgen opsturen</h2></b-col>
          </b-row>
          <b-row>
            <b-col v-for="(cat, name) in productsUnfreezePerCat.aftertomorrow" :key="'day-'+name" xl="3" md="6" @click="showModal(name, 'aftertomorrow')">
              <stats-card :title="name"
                          type="gradient-orange"
                          :sub-title="cat.toString()"
                          icon="ni ni-tag"
                          class="mb-2">
              </stats-card>
            </b-col>
          </b-row>
        </div>
      </div>
      <div v-else>
        <b-row>
          <b-col><h2>Niets te ontdooien</h2></b-col>
        </b-row>
      </div>
    </base-header>

    <!--Charts-->
    <b-container fluid class="mt--7">
      <!--Tables-->
      <b-row class="mt-5">
        <b-col xl="12" class="mb-5 mb-xl-0">
          <order-numbers-table></order-numbers-table>
        </b-col>
      </b-row>
      <!--End tables-->
    </b-container>

    <modal :show="modalShow" :size="'sm'" @close="modalShow = false">
      <template v-slot:header>
        <h5 class="modal-title" id="exampleModalLabel">{{ modalCat }}</h5>
      </template>
      <div>
        <div v-if="ordersUnfreezePerCat[modalTodayTomorrow][modalCat] && ordersUnfreezePerCat[modalTodayTomorrow][modalCat].length === 0">
          Geen
        </div>
          <div :key="order.order_number" v-for="order in ordersUnfreezePerCat[modalTodayTomorrow][modalCat]">
            <button type="button" class="btn-icon-clipboard" style="padding:1rem 1.5rem;">
              <div>
                <i class="ni ni-box-2"></i>
                <span>{{ order.order_number }}</span>
              </div>
            </button>
          </div>
      </div>
      <template v-slot:footer>
        <base-button type="primary" @click="modalShow = false">OK</base-button>
      </template>
    </modal>
  </div>
</template>
<script>
  // Components
  import StatsCard from '@/components/Cards/StatsCard';

  // Tables
  import OrderNumbersTable from './Dashboard/OrderNumbersTable';
  import { mapGetters } from 'vuex'
  import { Modal } from '@/components';

  export default {
    components: {
      StatsCard,
      OrderNumbersTable,
      Modal
    },
    data() {
      return {
        modalCat: null,
        modalShow: false,
        modalTodayTomorrow: 'today',
        isAfternoon: false,
        checkTimeout: 100
      };
    },
    computed: {
      ...mapGetters({
        productsUnfreezePerCat: 'orders/productsUnfreezePerCat',
        dateUnfreeze: 'orders/dateUnfreeze',
        ordersUnfreezePerCat: 'orders/ordersUnfreezePerCat'
      })
    },
    mounted(){
      let that = this;
      let channel = pusher.subscribe('messages');
      channel.bind('order-added', function(data) {
        that.$store.commit('orders/ADD', {order: data.order, cat: 'total'})
      });
      channel.bind('order-updated', function(data) {
        if(data.order) {
          that.$store.commit('orders/UPDATE', {order: data.order, cat: 'total'})
        }
      });
      channel.bind('order-removed', function(data) {
        if(data.order) {
          that.$store.commit('orders/REMOVE', {order: data.order, cat: 'total'})
        }
      });
      channel.bind('future-order-added', function(data) {
        if(data.order) {
          that.$store.commit('orders/ADDFUTURE', {cat: data.cat})
        }
      });
      channel.bind('future-order-removed', function(data) {
        if(data.order) {
          that.$store.commit('orders/REMOVEFUTURE', {order: data.cat})
        }
      });

      this.$store.dispatch('orders/getOrders')

      this.checkIfAfternoon();

      this.$nextTick(function () {
        window.setInterval(() => {
          this.checkIfAfternoon();
        }, that.checkTimeout);
      })
    },
    methods: {
      showModal(cat, todayTomorrow) {
        this.modalTodayTomorrow = todayTomorrow
        this.modalCat = cat
        this.modalShow = true
      },

      checkIfAfternoon() {
        let today = new Date()
        if([0, 6].includes(today.getDay())) {
          this.isAfternoon = false // don't show next day in weekend, just show monday (since weekends are already skipped in php)
        } else {
          this.isAfternoon = (today.getHours() >= 15 || Object.keys(this.productsUnfreezePerCat.today).length === 0)
          if(Object.keys(this.productsUnfreezePerCat.today).length > 0 || Object.keys(this.productsUnfreezePerCat.tomorrow).length > 0) {
            this.checkTimeout = 60000
          }
        }
      }
    }
  };
</script>
